import React, { Component } from 'react';
import { getImgUrl , limitText } from "../../Utility/Utility"
import { Img } from '../UI/UI';

export const DealItem = ( props ) => {

	const callToActionText = ( props.callToActionText != undefined )  ? props.callToActionText  : 'BUCHEN SIE JETZT'; 
	const cssClass = ( props.cssClass != undefined )  ? props.cssClass  : ''; 
	const isReminder  = ( props.isReminder  != undefined )  ? props.isReminder  : '';  
	const job = ( props.job != undefined )  ? props.job  : ''; 
	
    let new_day = new Date();
	     // alert(new_day);
	let corrent_month = new_day.getMonth();
	     // alert(corrent_month);
    let chinise_blackfriday = new_day.getDate();
    let world_blackfriday = new_day.getDate();
    let blackfriday_friday_html ='';
	
    if ( (chinise_blackfriday == 11 || world_blackfriday == 29) && corrent_month == 10 ) {
				     
		blackfriday_friday_html =<div className="ac-black-friday"><img src="https://en.citiesbreak.com/twocities/assets/img/sale.png" className="img-responsive" /></div>;
	}

	let jobHTML = null;
	
    if (job != '') {
		jobHTML = 	<small className="job-wrapper">
						<br/>
						({job})
					</small>
	}
	let  html = null;
	if ( isReminder ) {
		html = <div className={"deal-item " + cssClass}>
			<div className="inner">
				<a target="_blank" data-agent={props.brand} href={props.bookNowLink}>
				<div className="brand-wrapper">
					<h3>
						{props.brand}
					</h3>
				</div>
				
				<div className="deal-img-desc-wrapper">
					<div className="deal-desc-wrapper">
						<p className={props.descFontSize}>
							{limitText(props.desc , 100 )}
						</p>
					</div>
					<div className="deal-img-wrapper">
						<Img desktopImg={ props.brandImg }/>
					</div>			
				</div>

				<div className="price-wrapper">
					<h3>
						{props.price}
						{jobHTML}
					</h3>
				</div>
				
				</a>
			</div>
		</div>
	}else {

		html = <div className={"deal-item " + cssClass}>
			<div className="inner">
				<a target="_blank" href={props.bookNowLink}>
				{blackfriday_friday_html}
				<div className="brand-wrapper">
					<h3>
						{props.brand}
					</h3>
				</div>
				<div className="price-wrapper">
					<p>
						<small className="small">Ab</small> {props.price}
						{jobHTML}
					</p>
				</div>
				<div className="deal-img-desc-wrapper">
					<div className="deal-desc-wrapper">
						<p className={props.descFontSize}>
							{limitText(props.desc , 100 )}
						</p>
					</div>
					<div className="deal-img-wrapper">
						<Img desktopImg={ props.brandImg }/>
					</div>			
				</div>
				<div className="book-now-wrapper">
					{callToActionText} > 
				</div>
				</a>
			</div>
		</div>

	}
	return(html)
}


// WEBPACK FOOTER //
// ./src/Components/Deals/DealItem.js